export const analizarDatos = (datos) => {
  if (!datos) return null;
  
  return {
    mensaje: `Se analizó el archivo ${datos.meta?.nombreArchivo || 'desconocido'} y se encontraron ${datos.filasTotales || 0} filas.`,
    datosExtra: {
      tipoArchivo: datos.meta?.tipo || 'desconocido',
      columnas: datos.columnas?.map(c => c.nombre).join(', ') || 'Ninguna',
      totalFilas: datos.filasTotales || 0,
      advertencias: datos.advertencias?.join(' | ') || 'Sin advertencias'
    }
  };
};

export default analizarDatos;